// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2hLog","calendarButtons":"ClockData_calendarButtons__PvYRr"};